import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  // theme: { light: true },
  theme: {
    themes: {
      light: {
        primary: '#258bf5',
        secondary: '#f0f0f0',
        // accent: '#8c9eff',
      },
    },
  },
});
